import { X, Clock, Sun, Repeat, ShieldAlert, Sparkles, Target, Heart } from "lucide-react";

export const SheetSection = ({ icon: Icon, label, text, testid }) =>
  text ? (
    <div data-testid={testid}>
      <p className="font-ui text-[11px] tracking-[0.2em] uppercase text-[#C9A24B] inline-flex items-center gap-1.5">
        <Icon size={13} /> {label}
      </p>
      <p className="font-sans text-sm text-[#1F2A24]/80 mt-1 whitespace-pre-line leading-relaxed">{text}</p>
    </div>
  ) : null;

export const CapsuleFiche = ({ c }) => (
  <div className="space-y-5">
    <SheetSection icon={Target} label="Intention" text={c.intention} testid="ceda-fiche-intention" />
    <SheetSection icon={Sparkles} label="Présentation" text={c.presentation} testid="ceda-fiche-presentation" />
    <SheetSection icon={Heart} label="Bénéfice de bien-être recherché" text={c.benefit} testid="ceda-fiche-benefit" />
    <SheetSection icon={Sparkles} label="Conseils d'utilisation" text={c.usage_tips} testid="ceda-fiche-tips" />
  </div>
);

export const CapsulePosologie = ({ c }) => {
  if (!c.frequency && !c.session_duration && !c.best_moment && !c.precautions) return null;
  return (
    <div className="rounded-2xl bg-[#F8F5EE] border border-[#E8DCC4] p-5" data-testid="ceda-posologie">
      <p className="font-serif text-lg text-[#1F2A24]">Posologie de pratique</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-3">
        <SheetSection icon={Repeat} label="Fréquence" text={c.frequency} />
        <SheetSection icon={Clock} label="Durée d'une séance" text={c.session_duration} />
        <SheetSection icon={Sun} label="Moment conseillé" text={c.best_moment} />
        <SheetSection icon={ShieldAlert} label="Précautions" text={c.precautions} />
      </div>
      <p className="font-sans text-[11px] text-[#1F2A24]/50 mt-4">
        Recommandations de pratique bien-être, et non une posologie médicale.
      </p>
    </div>
  );
};

export const CapsuleSheet = ({ c, family, onClose, footer }) => (
  <div className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose}>
    <div
      data-testid="ceda-capsule-sheet"
      onClick={(e) => e.stopPropagation()}
      className="bg-white w-full sm:max-w-2xl max-h-[92vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl p-6 md:p-9 animate-in fade-in slide-in-from-bottom-4 duration-300"
    >
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="font-ui text-xs tracking-[0.2em] text-[#C9A24B]">{c.code} {family ? `· ${family.name}` : ""}</p>
          <h2 className="font-serif text-3xl text-[#1F2A24] mt-1">{c.title}</h2>
        </div>
        <button data-testid="ceda-sheet-close" onClick={onClose} className="p-2 rounded-full hover:bg-[#F6F2E9]"><X size={20} /></button>
      </div>
      <div className="mt-6 space-y-6">
        <CapsuleFiche c={c} />
        <CapsulePosologie c={c} />
      </div>
      {footer && <div className="mt-7">{footer}</div>}
    </div>
  </div>
);
